export default __webpack_public_path__ + "static/media/pilz-05.8a2045b5.png";